(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("tslib"), require("immutable"), require("action-emitter"), require("flux"), require("flux/utils"));
	else if(typeof define === 'function' && define.amd)
		define(["tslib", "immutable", "action-emitter", "flux", "flux/utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("tslib"), require("immutable"), require("action-emitter"), require("flux"), require("flux/utils")) : factory(root["tslib"], root["immutable"], root["action-emitter"], root["flux"], root["flux/utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_22__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var flux = __webpack_require__(21);
var DispatcherClass = /** @class */ (function (_super) {
    tslib_1.__extends(DispatcherClass, _super);
    function DispatcherClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Dispatches a payload to all registered callbacks.
     *
     * @param {TAction} dispatcherMessage - Instance of a class.
     */
    DispatcherClass.prototype.dispatch = function (dispatcherMessage) {
        var payload = {
            action: dispatcherMessage
        };
        try {
            if (!this.isDispatching()) {
                _super.prototype.dispatch.call(this, payload);
            }
            else {
                throw new Error("SimplrFlux.Dispatcher.dispatch(): Cannot dispatch in the middle of a dispatch.");
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    return DispatcherClass;
}(flux.Dispatcher));
exports.DispatcherClass = DispatcherClass;
exports.Dispatcher = new DispatcherClass();


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var utils_1 = __webpack_require__(22);
var Immutable = __webpack_require__(1);
var dispatcher_1 = __webpack_require__(2);
var ReduceStore = /** @class */ (function (_super) {
    tslib_1.__extends(ReduceStore, _super);
    /**
     * Creates an instance of ReduceStore.
     *
     * @param {Flux.Dispatcher<DispatcherMessage<any>>} [dispatcher = Dispatcher] - Dispatcher instance.
     */
    function ReduceStore(dispatcher) {
        var _this = _super.call(this, dispatcher || dispatcher_1.Dispatcher) || this;
        /**
         * Actions handlers list.
         *
         */
        _this.actionsHandlers = Immutable.Map();
        _this.startNewSession();
        return _this;
    }
    Object.defineProperty(ReduceStore.prototype, "currentSession", {
        /**
         * Return current session timestamp.
         */
        get: function () {
            return this.session;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Start a new session.
     *
     */
    ReduceStore.prototype.startNewSession = function () {
        this.session = +new Date();
        this.inCleanUpState = false;
    };
    /**
     * Generate new initial state start new session.
     *
     * @param {TState} state - Current store state.
     */
    ReduceStore.prototype.getCleanStateAndStartNewSession = function (state) {
        var newState;
        if (this.storeWillCleanUp != null) {
            var cleanupState = this.storeWillCleanUp();
            if (cleanupState != null) {
                newState = cleanupState;
            }
        }
        if (newState == null) {
            newState = this.getInitialState();
        }
        this.startNewSession();
        return newState;
    };
    /**
     * Reduces the current state, and an action to the new state of this store.
     * All subclasses must implement this method.
     * This method should be pure and have no side-effects.
     *
     * @param {TState} state - Current store state.
     * @param {DispatcherMessage<any>} payload - Dispatched payload message.
     */
    ReduceStore.prototype.reduce = function (state, payload) {
        var _this = this;
        if (this.inCleanUpState) {
            state = this.getCleanStateAndStartNewSession(state);
        }
        this.actionsHandlers.forEach(function (handler, action) {
            if (payload.action instanceof action && _this.shouldHandleAction(payload.action, state)) {
                var newState = handler(payload.action, state);
                if (newState != null) {
                    state = newState;
                }
            }
        });
        if (this.inCleanUpState) {
            state = this.getCleanStateAndStartNewSession(state);
        }
        return state;
    };
    /**
     * Checks if two versions of state are the same.
     * You do not need to override.
     *
     * @param {TState} startingState - Starting state (current).
     * @param {TState} endingState - Ending state (updated).
     */
    ReduceStore.prototype.areEqual = function (startingState, endingState) {
        if (startingState != null &&
            endingState != null &&
            typeof startingState === "object" &&
            !Immutable.Iterable.isIterable(startingState)) {
            var startingKeys = Object.keys(startingState);
            if (startingKeys.length === 0) {
                return startingState === endingState;
            }
            var endingKeys = Object.keys(endingState);
            if (startingKeys.length !== endingKeys.length) {
                return false;
            }
            var areEqual = true;
            for (var i = 0; i < startingKeys.length; i++) {
                var key = startingKeys[i];
                if (startingState[key] !== endingState[key]) {
                    areEqual = false;
                    break;
                }
            }
            return areEqual;
        }
        else {
            return startingState === endingState;
        }
    };
    /**
     * This method will return the dispatcher for this store.
     *
     */
    ReduceStore.prototype.getDispatcher = function () {
        return _super.prototype.getDispatcher.call(this);
    };
    /**
     * Check if action should handled.
     * By default always return true.
     *
     * @param {Object} action - Action payload data.
     * @param {TState} state - Updated store state.
     */
    ReduceStore.prototype.shouldHandleAction = function (action, state) {
        return true;
    };
    /**
     * Clean up all store data.
     * This method is only available in the middle of a dispatch!
     */
    ReduceStore.prototype.cleanUpStore = function () {
        if (!dispatcher_1.Dispatcher.isDispatching()) {
            throw new Error("SimplrFlux.ReduceStore.cleanUpStore() [" + this.constructor.name + "]: " +
                "Cannot clean up store when dispatch is not in the middle of a dispatch.");
        }
        this.inCleanUpState = true;
    };
    /**
     * Register specified action handler in this store.
     *
     * @param {Function} action - Action class function.
     * @param {ActionHandler<TClass, TState>} handler - Action handler function.
     */
    ReduceStore.prototype.registerAction = function (action, handler) {
        var actionType = typeof action;
        if (actionType !== "function") {
            throw new Error("SimplrFlux.ReduceStore.registerAction() [" + this.constructor.name + "]: " +
                ("cannot register action with 'action' type of '" + actionType + "'."));
        }
        var handlerType = typeof handler;
        if (handlerType !== "function") {
            throw new Error("SimplrFlux.ReduceStore.registerAction() [" + this.constructor.name + "]: " +
                ("cannot register action with 'handler' type of '" + handlerType + "'."));
        }
        if (this.actionsHandlers.has(action)) {
            throw new Error("SimplrFlux.ReduceStore.registerAction() [" + this.constructor.name + "]: " +
                ("Handler for action '" + action.name + "' has already been registered."));
        }
        this.actionsHandlers = this.actionsHandlers.set(action, handler);
    };
    return ReduceStore;
}(utils_1.ReduceStore));
exports.ReduceStore = ReduceStore;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DataMapStoreUpdatedAction = /** @class */ (function () {
    function DataMapStoreUpdatedAction(storeId) {
        this.storeId = storeId;
    }
    Object.defineProperty(DataMapStoreUpdatedAction.prototype, "StoreId", {
        get: function () {
            return this.storeId;
        },
        enumerable: true,
        configurable: true
    });
    return DataMapStoreUpdatedAction;
}());
exports.DataMapStoreUpdatedAction = DataMapStoreUpdatedAction;
var DataMapStoreCleanUpAction = /** @class */ (function () {
    function DataMapStoreCleanUpAction(storeId) {
        this.storeId = storeId;
    }
    Object.defineProperty(DataMapStoreCleanUpAction.prototype, "StoreId", {
        get: function () {
            return this.storeId;
        },
        enumerable: true,
        configurable: true
    });
    return DataMapStoreCleanUpAction;
}());
exports.DataMapStoreCleanUpAction = DataMapStoreCleanUpAction;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Item class in map store state.
 *
 * @export
 * @class Item
 * @template T
 */
var Item = /** @class */ (function () {
    /**
     * Construct new item.
     *
     * @param {ItemStatus} [status=ItemStatus.Init] - Initial item status.
     * @param {T} [value=undefined] - Initial item value.
     */
    function Item(status, value) {
        this.Status = (status != null) ? status : 0 /* Init */;
        this.Value = (value != null) ? value : undefined;
    }
    return Item;
}());
exports.Item = Item;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Immutable = __webpack_require__(1);
var InvalidationHandler = /** @class */ (function () {
    function InvalidationHandler() {
        this.pendingDeletionItems = Immutable.List();
    }
    Object.defineProperty(InvalidationHandler.prototype, "IsWaiting", {
        /**
         * Handler has keys to invalidate and waiting for start.
         */
        get: function () {
            return this.pendingDeletionItems.size > 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set keys for invalidation.
     *
     * @param {string[]} keys - List of keys.
     */
    InvalidationHandler.prototype.Prepare = function (keys) {
        var _this = this;
        if (keys.length === 0) {
            return;
        }
        this.pendingDeletionItems.withMutations(function (mutablePendingDeletionItems) {
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (_this.pendingDeletionItems.indexOf(key) === -1) {
                    _this.pendingDeletionItems = _this.pendingDeletionItems.push(key);
                }
            }
        });
    };
    /**
     * Start invalidating pending keys and return new state with list of removed keys.
     *
     * @param {Items<TValue>} state - Store state.
     */
    InvalidationHandler.prototype.Start = function (state) {
        var _this = this;
        var removed = new Array(this.pendingDeletionItems.size);
        state = state.withMutations(function (mutableState) {
            var index = 0;
            _this.pendingDeletionItems.forEach(function (key) {
                if (key == null) {
                    return;
                }
                if (mutableState.has(key)) {
                    mutableState = mutableState.delete(key);
                }
                removed[index++] = key;
            });
        });
        this.pendingDeletionItems = Immutable.List();
        return {
            RemovedKeys: removed,
            State: state
        };
    };
    return InvalidationHandler;
}());
exports.InvalidationHandler = InvalidationHandler;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var item_1 = __webpack_require__(5);
var Immutable = __webpack_require__(1);
var OBJECT_FREEZE_EXIST = Object != null && Object.freeze != null;
var QueuesHandler = /** @class */ (function () {
    function QueuesHandler() {
        this.queues = Immutable.Map();
    }
    /**
     * Freeze specified object if global function exists.
     *
     * @param {TObject} obj - Object to freeze.
     */
    QueuesHandler.prototype.tryToFreezeObject = function (obj) {
        if (!OBJECT_FREEZE_EXIST) {
            return obj;
        }
        return Object.freeze(obj);
    };
    /**
     * Set item data by specified key.
     *
     * @param {string} key - Item key.
     * @param {(TValue | undefined)} value - Item value.
     * @param {ItemStatus} status - Item status.
     */
    QueuesHandler.prototype.Set = function (key, value, status) {
        var newValue = new item_1.Item(status, value);
        newValue = this.tryToFreezeObject(newValue);
        this.queues = this.queues.set(key, newValue);
        return newValue;
    };
    /**
     * Create new initial item with specified key.
     *
     * @param {string} key - Item key.
     */
    QueuesHandler.prototype.Create = function (key) {
        var newValue = new item_1.Item(0 /* Init */);
        newValue = this.tryToFreezeObject(newValue);
        this.queues = this.queues.set(key, newValue);
        return newValue;
    };
    /**
     * Set specified status for item by key.
     *
     * @param {string} key - Item key.
     * @param {ItemStatus} status - Item status.
     */
    QueuesHandler.prototype.SetItemStatus = function (key, status) {
        var _this = this;
        if (!this.queues.has(key)) {
            return this.Set(key, undefined, status);
        }
        this.queues = this.queues.update(key, function (oldValue) {
            var newValue = new item_1.Item(status, oldValue.Value);
            return _this.tryToFreezeObject(newValue);
        });
        return this.queues.get(key);
    };
    /**
     * Set specified status for multiple items by keys.
     *
     * @param {Array<string>} keys - List of items keys.
     * @param {ItemStatus} status - Item status.
     */
    QueuesHandler.prototype.SetMultipleItemsStatus = function (keys, status) {
        var _this = this;
        this.queues = this.queues.withMutations(function (mutableQueues) {
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (!mutableQueues.has(key)) {
                    continue;
                }
                mutableQueues = mutableQueues.update(key, function (oldValue) {
                    var newValue = new item_1.Item(status, oldValue.Value);
                    return _this.tryToFreezeObject(newValue);
                });
            }
        });
    };
    /**
     * Returns filtered items by specified item status.
     *
     * @param {ItemStatus} status - Item status.
     */
    QueuesHandler.prototype.GetFilteredItems = function (filter) {
        return this.queues.filter(function (x) { return x != null && filter(x); }).toMap();
    };
    /**
     * Returns filtered items keys by specified item status.
     *
     * @param {ItemStatus} status - Item status.
     * @returns {string[]}
     */
    QueuesHandler.prototype.GetFilteredItemsKeys = function (filter) {
        return this.queues
            .filter(function (value, key) { return (key != null && value != null && filter(value, key)); })
            .map(function (value, key) { return key; })
            .toArray();
    };
    /**
     * Returns the value with specified key from queues list.
     * Or `undefined` if item with specified key doesn't exist in queues list.
     *
     * @param {string} key - Item key.
     * @returns {Item<TValue> | undefined}
     */
    QueuesHandler.prototype.Get = function (key) {
        return this.queues.get(key);
    };
    /**
     * Return true if item with specified key exists in queues list.
     *
     * @param {string} key - Item key.
     * @returns {boolean}
     */
    QueuesHandler.prototype.Has = function (key) {
        return this.queues.has(key);
    };
    /**
     * Remove specified item by key from queues list.
     *
     * @param {string} key - Item key.
     */
    QueuesHandler.prototype.Remove = function (key) {
        this.queues = this.queues.remove(key);
    };
    /**
     * Remove multiple items by keys from queues list.
     *
     * @param {Array<string>} keys - Items keys list.
     */
    QueuesHandler.prototype.RemoveMultiple = function (keys) {
        this.queues = this.queues.withMutations(function (mutableQueues) {
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (key == null) {
                    continue;
                }
                mutableQueues = mutableQueues.remove(key);
            }
        });
    };
    /**
     * Remove all items from queues list.
     *
     */
    QueuesHandler.prototype.RemoveAll = function () {
        this.queues = Immutable.Map();
    };
    return QueuesHandler;
}());
exports.QueuesHandler = QueuesHandler;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var item_status_1 = __webpack_require__(14);
exports.ItemStatus = item_status_1.ItemStatus;
var item_1 = __webpack_require__(5);
exports.Item = item_1.Item;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var action_emitter_1 = __webpack_require__(20);
exports.Emitter = new action_emitter_1.ActionEmitter();


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var item_is_pending_1 = __webpack_require__(16);
exports.ItemIsPending = item_is_pending_1.ItemIsPending;
var items_status_resolver_1 = __webpack_require__(17);
exports.ItemsStatusResolver = items_status_resolver_1.ItemsStatusResolver;
var wait_for_store_change_1 = __webpack_require__(18);
exports.WaitForStoreChange = wait_for_store_change_1.WaitForStoreChange;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Immutable = __webpack_require__(1);
var reduce_store_1 = __webpack_require__(3);
var queues_handler_1 = __webpack_require__(7);
var data_store_actions_1 = __webpack_require__(15);
var invalidation_handler_1 = __webpack_require__(6);
var DataStore = /** @class */ (function (_super) {
    tslib_1.__extends(DataStore, _super);
    /**
     * Creates an instance of DataStore.
     *
     * @param {Flux.Dispatcher<DispatcherMessage<any>>} [dispatcher] - Dispatcher instance.
     */
    function DataStore(dispatcher) {
        var _this = _super.call(this, dispatcher) || this;
        _this.queuesHandler = new queues_handler_1.QueuesHandler();
        _this.invalidationHandler = new invalidation_handler_1.InvalidationHandler();
        return _this;
    }
    /**
     * Dispatch action that this store has changed.
     */
    DataStore.prototype.dispatchChanges = function () {
        this.getDispatcher().dispatch(new data_store_actions_1.StoreUpdateAction(this.getDispatchToken()));
    };
    /**
     * Asynchronously dispatch action that this store has changed.
     * Dispatch process will be cancelled if specified `stillValid` method return false.
     *
     * @param {() => boolean} stillValid - Is dispatch still valid.
     */
    DataStore.prototype.dispatchChangesAsync = function (stillValid) {
        var _this = this;
        setTimeout(function () {
            if (stillValid == null || stillValid()) {
                _this.dispatchChanges();
            }
        });
    };
    /**
     * Start resolving promise and resolving item by key.
     *
     * @param {string} key - Item key.
     * @param {() => Promise<TValue>} promiseFactory - Function which return a promise.
     */
    DataStore.prototype.startRequestingData = function (key, promiseFactory) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, status_1, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, promiseFactory()];
                    case 1:
                        response = _a.sent();
                        status_1 = (response != null) ? 16 /* Loaded */ : 64 /* NoData */;
                        this.queuesHandler.Set(key, response || undefined, status_1);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.queuesHandler.SetItemStatus(key, 128 /* Failed */);
                        return [3 /*break*/, 3];
                    case 3:
                        this.dispatchChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Return specified item value.
     * Create new item in queues if not exists in store state.
     *
     * @param {string} key - Item key.
     * @param {boolean} noCache - Update cached item from the server.
     */
    DataStore.prototype.getItem = function (key, noCache) {
        if (key != null && this.has(key) && !noCache) {
            return this.getState().get(key);
        }
        if (this.queuesHandler.Has(key)) {
            return this.queuesHandler.Get(key);
        }
        return this.queuesHandler.Create(key);
    };
    /**
     * Move completed items from queues to state.
     *
     * @param {Item<any>} state - Current store state.
     */
    DataStore.prototype.moveFromQueuesToState = function (state) {
        var moveList = this.queuesHandler.GetFilteredItems(function (x) { return x.Status >= 16 /* Loaded */; });
        if (moveList.size === 0) {
            return undefined;
        }
        var keysForRemove = new Array(moveList.size);
        var newState = state.withMutations(function (mutableState) {
            var index = 0;
            moveList.forEach(function (item, key) {
                if (item == null || key == null) {
                    return;
                }
                mutableState.set(key, item);
                keysForRemove[index++] = key;
            });
        });
        this.queuesHandler.RemoveMultiple(keysForRemove);
        return newState;
    };
    /**
     * Constructs the initial state for this store.
     * This is called once during construction of the store.
     *
     * @returns {Items<any>}
     */
    DataStore.prototype.getInitialState = function () {
        return Immutable.Map({});
    };
    /**
     * Reduces the current state, and an action to the new state of this store.
     * All subclasses must implement this method.
     * This method should be pure and have no side-effects.
     *
     * @param {Items<any>} state - Current store state.
     * @param {DispatcherMessage<any>} payload - Dispatched message from dispatcher.
     * @returns {Items<any>}
     */
    DataStore.prototype.reduce = function (state, payload) {
        if (payload.action instanceof data_store_actions_1.StoreUpdateAction) {
            if (this.getDispatchToken() === payload.action.DispatchToken) {
                var newState = this.moveFromQueuesToState(state);
                if (newState != null) {
                    state = newState;
                }
            }
        }
        state = _super.prototype.reduce.call(this, state, payload);
        if (this.invalidationHandler.IsWaiting) {
            var result = this.invalidationHandler.Start(state);
            this.queuesHandler.RemoveMultiple(result.RemovedKeys);
            state = result.State;
        }
        return state;
    };
    /**
     * Return specified item value.
     * Start resolving data with `promiseFactory`.
     *
     * @param {string} key - Item key.
     * @param {() => Promise<TValue>} promiseFactory - Function which return promise with value resolver.
     * @param {boolean} [noCache=false] - Use data without cache.
     * @returns {Item<TValue>}
     */
    DataStore.prototype.getValueFromState = function (key, promiseFactory, noCache) {
        if (noCache === void 0) { noCache = false; }
        var value = this.getItem(key, noCache);
        if (value.Status === 0 /* Init */) {
            value = this.queuesHandler.SetItemStatus(key, 8 /* Pending */);
            this.startRequestingData(key, promiseFactory);
        }
        return value;
    };
    /**
     * Check if the cache has a particular key.
     *
     * @param {string} key - Item key.
     * @returns {boolean}
     */
    DataStore.prototype.has = function (key) {
        return this.getState().has(key);
    };
    /**
     * Remove item from cache, if exist.
     *
     * @param {string} key - Item key.
     */
    DataStore.prototype.invalidateCache = function (key) {
        this.invalidateCacheMultiple([key]);
    };
    /**
     * Remove multiple items from cache, if exist.
     *
     * @param {string[]} keys - Items keys.
     */
    DataStore.prototype.invalidateCacheMultiple = function (keys) {
        var _this = this;
        if (keys.length > 0) {
            this.invalidationHandler.Prepare(keys);
            this.dispatchChangesAsync(function () { return _this.invalidationHandler.IsWaiting; });
        }
    };
    return DataStore;
}(reduce_store_1.ReduceStore));
exports.DataStore = DataStore;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Immutable = __webpack_require__(1);
var reduce_store_1 = __webpack_require__(3);
var dispatcher_1 = __webpack_require__(2);
var actions_1 = __webpack_require__(4);
var queues_handler_1 = __webpack_require__(7);
var invalidation_handler_1 = __webpack_require__(6);
var ERROR_GET_ALL_WRONG_PARAM = "'keys' param accept only 'Array<string>', " +
    "'Immutable.Set<string>' or 'Immutable.List<string>'.";
/**
 * MapStore to cache data by id.
 *
 * @export
 * @abstract
 * @class MapStore
 * @extends {ReduceStore<Items<TValue>>}
 * @template TValue
 */
var MapStore = /** @class */ (function (_super) {
    tslib_1.__extends(MapStore, _super);
    /**
     * Creates an instance of MapStore.
     *
     * @param {Flux.Dispatcher<DispatcherMessage<any>>} [dispatcher] - Dispatcher instance.
     */
    function MapStore(dispatcher) {
        var _this = _super.call(this, dispatcher) || this;
        /**
         * Return initial queues value.
         */
        _this.getInitialQueues = function () { return new queues_handler_1.QueuesHandler(); };
        /**
         * With a large amount of requests MapStore throttles them.
         * This property defines interval between portions of requests.
         *
         * @protected
         * @type {number}
         */
        _this.RequestsIntervalInMs = 50;
        _this.startRequestingData = function (initial) {
            if (initial === void 0) { initial = false; }
            if (!initial) {
                _this.requestIntervalTimer = undefined;
            }
            var ids = _this.queuesHandler.GetFilteredItemsKeys(function (item) { return item.Status === 0 /* Init */; });
            if (ids.length === 0) {
                return;
            }
            var currentSession = _this.currentSession;
            _this.queuesHandler.SetMultipleItemsStatus(ids, 8 /* Pending */);
            var onSuccess = _this.onRequestSuccess.bind(_this, currentSession);
            var onFailed = _this.onRequestFailed.bind(_this, currentSession, ids);
            var maybePromise = _this.requestData(ids, onSuccess, onFailed);
            if (_this.isPromise(maybePromise)) {
                maybePromise
                    .then(onSuccess)
                    .catch(function (error) {
                    _this.queuesHandler.SetMultipleItemsStatus(ids, 128 /* Failed */);
                    _this.dispatchChanges();
                });
            }
        };
        _this.onRequestSuccess = function (currentSession, values) {
            if (currentSession !== _this.currentSession) {
                console.warn(_this.buildError("requestData", "RequestData method was resolved after store data has been cleared. Check `this.cleanUpStore()` method calls."));
                return;
            }
            if (values == null) {
                console.error(_this.buildError("requestData", "Success values cannot be '" + values + "'."));
                return;
            }
            _this.updateQueuesFromRequest(values);
            _this.dispatchChanges();
        };
        _this.onRequestFailed = function (currentSession, ids, values) {
            if (currentSession !== _this.currentSession) {
                console.warn(_this.buildError("requestData", "RequestData method was rejected after store data has been cleared. Check `this.cleanUpStore()` method calls."));
                return;
            }
            if (values == null) {
                _this.queuesHandler.SetMultipleItemsStatus(ids, 128 /* Failed */);
            }
            else if (Array.isArray(values)) {
                _this.queuesHandler.SetMultipleItemsStatus(values, 128 /* Failed */);
            }
            else if (typeof values === "object") {
                var isExistResults_1 = false;
                var results_1 = {};
                Object.keys(values).forEach(function (id) {
                    var status = values[id];
                    results_1[status] = id;
                    if (!isExistResults_1) {
                        isExistResults_1 = true;
                    }
                });
                if (isExistResults_1) {
                    Object.keys(results_1).forEach(function (status) {
                        _this.queuesHandler.SetMultipleItemsStatus(ids, parseInt(status));
                    });
                }
                else {
                    _this.queuesHandler.SetMultipleItemsStatus(ids, 128 /* Failed */);
                }
            }
            else {
                _this.queuesHandler.SetMultipleItemsStatus(ids, 128 /* Failed */);
            }
            _this.dispatchChanges();
        };
        /**
         * Holds a function that will be invoked before store clean up.
         *
         * @protected
         * @type {() => void}
         */
        _this.storeWillCleanUp = function () {
            _this.queuesHandler.RemoveAll();
        };
        _this.queuesHandler = _this.getInitialQueues();
        _this.invalidationHandler = new invalidation_handler_1.InvalidationHandler();
        return _this;
    }
    /**
     * Build error with prefix and instance name.
     *
     * @private
     * @param {string} functionName
     * @param {string} message
     * @returns {string}
     */
    MapStore.prototype.buildError = function (functionName, message) {
        return "SimplrFlux.MapStore." + functionName + "() [" + this.constructor.name + "]: " + message;
    };
    MapStore.prototype.dispatchChanges = function () {
        dispatcher_1.Dispatcher.dispatch(new actions_1.DataMapStoreUpdatedAction(this.getDispatchToken()));
    };
    MapStore.prototype.dispatchChangesAsync = function () {
        var _this = this;
        setTimeout(function () {
            _this.dispatchChanges();
        });
    };
    /**
     * Update queues items from request.
     *
     * @private
     * @param {({ [id: string]: TValue | undefined })} values
     */
    MapStore.prototype.updateQueuesFromRequest = function (values) {
        /* tslint:disable */
        for (var key in values) {
            var value = values[key];
            var status_1 = void 0;
            if (value != null) {
                status_1 = 16 /* Loaded */;
            }
            else {
                value = undefined;
                status_1 = 64 /* NoData */;
            }
            this.queuesHandler.Set(key, value, status_1);
        }
    };
    /**
     * Request creator to load data from server.
     *
     * @private
     */
    MapStore.prototype.createRequest = function () {
        var _this = this;
        if (this.requestIntervalTimer != null) {
            return;
        }
        setTimeout(function () {
            _this.startRequestingData(true);
        });
        this.requestIntervalTimer = setTimeout(this.startRequestingData, this.RequestsIntervalInMs);
    };
    /**
     * Check if given function is Promise.
     *
     * @param {any} func - function
     */
    MapStore.prototype.isPromise = function (func) {
        return func != null && func.then != null && func.catch != null;
    };
    /**
     * Get the value of a particular key. Returns Value undefined and status if the key does not exist in the cache.
     *
     * @param {string} key - Requested item key.
     * @param {boolean} [noCache=false] - Update cached item from the server.
     */
    MapStore.prototype.get = function (key, noCache) {
        if (noCache === void 0) { noCache = false; }
        var item = this.getItem(key, noCache);
        this.createRequest();
        return item;
    };
    /**
     * Prefetch item by key.
     * @param {string} key - Requested item key.
     * @param {boolean} [noCache=false] = Update cached item from the server.
     */
    MapStore.prototype.Prefetch = function (key, noCache) {
        if (noCache === void 0) { noCache = false; }
        this.get(key, noCache);
    };
    MapStore.prototype.PrefetchAll = function (keys, noCache) {
        if (noCache === void 0) { noCache = false; }
        this.getAll(keys, undefined, noCache);
    };
    /**
     * Remove item from cache, if exist.
     *
     * @param {string} key - Requested item key.
     * @returns {void}
     */
    MapStore.prototype.InvalidateCache = function (key) {
        this.invalidationHandler.Prepare([key]);
        this.dispatchChangesAsync();
    };
    /**
     * Remove multiple items from cache, if exist.
     *
     * @param {string[]} keys - Requested item key.
     * @returns {void}
     */
    MapStore.prototype.InvalidateCacheMultiple = function (keys) {
        this.invalidationHandler.Prepare(keys);
        this.dispatchChangesAsync();
    };
    /**
     * Get the item value from state or add to queue.
     *
     * @param {string} key - Requested item key.
     * @param {boolean} noCache - Update cached item from the server.
     */
    MapStore.prototype.getItem = function (key, noCache) {
        var item;
        if (key != null && this.getState().has(key) && !noCache) {
            item = this.getState().get(key);
        }
        else {
            if (this.queuesHandler.Has(key)) {
                item = this.queuesHandler.Get(key);
            }
            else {
                item = this.queuesHandler.Create(key);
            }
        }
        return item;
    };
    MapStore.prototype.getAll = function (keys, prev, noCache) {
        var _this = this;
        if (noCache === void 0) { noCache = false; }
        var newKeys;
        var start = prev || this.getInitialState();
        if (keys != null) {
            if (keys instanceof Array) {
                try {
                    newKeys = Immutable.Set(keys);
                }
                catch (error) {
                    console.error(this.buildError("getAll", ERROR_GET_ALL_WRONG_PARAM));
                    newKeys = Immutable.Set();
                }
            }
            else if (Immutable.Set.isSet(keys)) {
                newKeys = keys;
            }
            else if (Immutable.OrderedSet.isOrderedSet(keys)) {
                newKeys = keys;
            }
            else if (Immutable.List.isList(keys)) {
                try {
                    newKeys = keys.toSet();
                }
                catch (error) {
                    newKeys = Immutable.Set();
                    console.error(this.buildError("getAll", ERROR_GET_ALL_WRONG_PARAM));
                }
            }
            else {
                console.error(this.buildError("getAll", ERROR_GET_ALL_WRONG_PARAM));
                newKeys = Immutable.Set();
            }
        }
        else {
            newKeys = Immutable.Set();
        }
        if (newKeys.size === 0) {
            return start;
        }
        return start.withMutations(function (resultMap) {
            // remove any old keys that are not in new keys or are no longer in the cache
            if (resultMap.size > 0) {
                resultMap.forEach(function (oldValue, oldKey) {
                    if (oldKey != null && (!newKeys.has(oldKey) || !_this.getState().has(oldKey))) {
                        resultMap.delete(oldKey);
                    }
                });
            }
            // then add all of the new keys that exist in the cache
            newKeys.forEach(function (key) {
                if (key != null) {
                    var item = _this.getItem(key, noCache);
                    resultMap.set(key, item);
                }
            });
            _this.createRequest();
        });
    };
    /**
     * Constructs the initial state for this store.
     * This is called once during construction of the store.
     *
     * @return {Immutable.Map<string, T>} Initial empty state.
     */
    MapStore.prototype.getInitialState = function () {
        return Immutable.Map({});
    };
    /**
     * Move completed items from queues to state.
     *
     * @private
     * @param {Items<TValue>} state
     * @returns {(Items<TValue> | undefined)}
     */
    MapStore.prototype.moveFromQueuesToState = function (state) {
        var _this = this;
        var moveList = this.queuesHandler.GetFilteredItemsKeys(function (x) { return [16 /* Loaded */, 64 /* NoData */, 128 /* Failed */].indexOf(x.Status) !== -1; });
        if (moveList.length > 0) {
            return state.withMutations(function (stateMap) {
                for (var i = 0; i < moveList.length; i++) {
                    var key = moveList[i];
                    var item = _this.queuesHandler.Get(key);
                    if (item != null) {
                        stateMap.set(key, tslib_1.__assign({}, item));
                    }
                    _this.queuesHandler.Remove(key);
                }
            });
        }
        return undefined;
    };
    /**
     * Reduces the current state, and an action to the new state of this store.
     * All subclasses must implement this method.
     * This method should be pure and have no side-effects.
     *
     * @param {Items<TValue>} state - Store state.
     * @param {DispatcherMessage<any>} payload - Dispatched message from simplr-dispatcher.
     * @return {Items<TValue>} Updated state with new data.
     */
    MapStore.prototype.reduce = function (state, payload) {
        if (payload.action instanceof actions_1.DataMapStoreUpdatedAction) {
            if (this.getDispatchToken() === payload.action.StoreId) {
                var newState = this.moveFromQueuesToState(state);
                if (newState != null) {
                    state = newState;
                }
            }
        }
        state = _super.prototype.reduce.call(this, state, payload);
        if (this.invalidationHandler.IsWaiting) {
            var result = this.invalidationHandler.Start(state);
            this.queuesHandler.RemoveMultiple(result.RemovedKeys);
            state = result.State;
        }
        return state;
    };
    /**
     * Access the value at the given key.
     * Return undefined if the key does not exist in the cache.
     *
     * @param {string} key
     * @returns {(Item<TValue> | undefined)}
     */
    MapStore.prototype.at = function (key) {
        if (this.getState().has(key)) {
            return this.get(key);
        }
        else if (this.queuesHandler.Has(key)) {
            return this.queuesHandler.Get(key);
        }
        else {
            console.error(this.buildError("at", "Expected store to have key " + key + "."));
            return undefined;
        }
    };
    /**
     * Check if the cache has a particular key.
     *
     * @param {string} key
     * @returns {boolean}
     */
    MapStore.prototype.has = function (key) {
        return this.getState().has(key) || this.queuesHandler.Has(key);
    };
    return MapStore;
}(reduce_store_1.ReduceStore));
exports.MapStore = MapStore;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Item status in map store state.
 *
 * @export
 * @enum {number}
 */
var ItemStatus;
(function (ItemStatus) {
    ItemStatus[ItemStatus["Init"] = 0] = "Init";
    ItemStatus[ItemStatus["Pending"] = 8] = "Pending";
    ItemStatus[ItemStatus["Loaded"] = 16] = "Loaded";
    ItemStatus[ItemStatus["NoData"] = 64] = "NoData";
    ItemStatus[ItemStatus["Failed"] = 128] = "Failed";
})(ItemStatus = exports.ItemStatus || (exports.ItemStatus = {}));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StoreUpdateAction = /** @class */ (function () {
    function StoreUpdateAction(dispatchToken) {
        this.dispatchToken = dispatchToken;
    }
    Object.defineProperty(StoreUpdateAction.prototype, "DispatchToken", {
        get: function () {
            return this.dispatchToken;
        },
        enumerable: true,
        configurable: true
    });
    return StoreUpdateAction;
}());
exports.StoreUpdateAction = StoreUpdateAction;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ItemIsPending(status) {
    return (status <= 8 /* Pending */);
}
exports.ItemIsPending = ItemIsPending;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ItemsStatusResolver() {
    var statuses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        statuses[_i] = arguments[_i];
    }
    var loadedCount = 0;
    var noDataCount = 0;
    var pendingCount = 0;
    for (var i = 0; i < statuses.length; i++) {
        var status_1 = statuses[i];
        switch (status_1) {
            case 128 /* Failed */:
                return status_1;
            case 16 /* Loaded */:
                loadedCount++;
                break;
            case 64 /* NoData */:
                noDataCount++;
                break;
            case 0 /* Init */:
            case 8 /* Pending */:
                pendingCount++;
                break;
        }
    }
    if (pendingCount > 0) {
        return 8 /* Pending */;
    }
    else if (loadedCount === 0 && noDataCount > 0) {
        return 64 /* NoData */;
    }
    else {
        return 16 /* Loaded */;
    }
}
exports.ItemsStatusResolver = ItemsStatusResolver;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function WaitForStoreChange(store) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    var listener = store.addListener(function () {
                        listener.remove();
                        resolve();
                    });
                })];
        });
    });
}
exports.WaitForStoreChange = WaitForStoreChange;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2), exports);
tslib_1.__exportStar(__webpack_require__(13), exports);
tslib_1.__exportStar(__webpack_require__(12), exports);
tslib_1.__exportStar(__webpack_require__(3), exports);
tslib_1.__exportStar(__webpack_require__(10), exports);
var Actions = __webpack_require__(4);
exports.Actions = Actions;
var Abstractions = __webpack_require__(8);
exports.Abstractions = Abstractions;
var Contracts = __webpack_require__(9);
exports.Contracts = Contracts;
var Helpers = __webpack_require__(11);
exports.Helpers = Helpers;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_21__;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ })
/******/ ]);
});